import { render, staticRenderFns } from "./EscorterDetails.vue?vue&type=template&id=23a37cce&scoped=true"
import script from "./EscorterDetails.vue?vue&type=script&lang=js"
export * from "./EscorterDetails.vue?vue&type=script&lang=js"
import style0 from "./EscorterDetails.vue?vue&type=style&index=0&id=23a37cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a37cce",
  null
  
)

export default component.exports